import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { FixedScrollDirective, SharedComponentsModule } from 'core/shared-components';
import { DsgTranslatePipe } from '../../pipes/translate.pipe';
import { MobileToolbarContentDirective } from '../../root/sidenav/mobile-toolbar-content.directive';
import { DataGridModule } from '../../shared-components/data-grid/data-grid.module';
import { SignProcessWizardModule } from '../sign-process-wizard/sign-process-wizard.module';
import { ProcessActionTemplateComponent } from './process-action-template/process-action-template.component';
import { ProcessOverviewComponent } from './process-overview.component';
import { ProcessOverviewDetailComponent } from './process-overview.detail/process-overview.detail.component';



@NgModule({
  declarations: [
    ProcessOverviewComponent,
    ProcessOverviewDetailComponent,
    ProcessActionTemplateComponent
  ],

  imports: [
    CommonModule,
    DataGridModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    DsgTranslatePipe,
    MatMenuModule,
    SignProcessWizardModule,
    SharedComponentsModule,
    FixedScrollDirective,
    MobileToolbarContentDirective
  ]
})
export class ProcessOverviewModule { }
